var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.812 12.907 12.877 73.603c-.79 1.334.171 3.02 1.72 3.02h71.871c1.55 0 2.51-1.686 1.721-3.02L52.254 12.907c-.774-1.308-2.667-1.308-3.442 0z",
    stroke: "#F29F18",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 37.5a2.5 2.5 0 0 0-2.5 2.5v12.5a2.5 2.5 0 0 0 5 0V40a2.5 2.5 0 0 0-2.5-2.5zm0 20a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z",
    fill: "#F29F18"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v100H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleWarningIcon);
export default __webpack_public_path__ + "static/media/triangle-warning-icon.0977b997e04d2658e419136ead4043d2.svg";
export { ForwardRef as ReactComponent };